<template>
    <vx-expandable-card v-if="props.expandable">
        <template v-slot:header>
            <slot name="header"></slot>
        </template>
        <template v-slot:headerSubtitle>
            <slot name="headerSubtitle"></slot>
        </template>
        <template v-slot:content>
            <slot name="content"></slot>
        </template>
    </vx-expandable-card>
    <div v-else class="flex flex-col gap-4">
        <div>
            <div class="font-extrabold text-slate-700 text-xl">
                <slot name="header"></slot>
            </div>
            <div class="text-sm text-slate-500">
                <slot name="headerSubtitle"></slot>
            </div>
        </div>
        <slot name="content"></slot>
    </div>
</template>

<script lang="ts" setup>
import { VxExpandableCard } from '@voxie/frontend-components';

const props = withDefaults(
    defineProps<{
        expandable?: boolean;
    }>(),
    {
        expandable: true,
    }
);
</script>
